/**
 * @typedef ConfirmModalButton
 * @type {object}
 * @property {string} text                 Button text
 * @property {string} color                Button color
 * @property {('resolve','reject')} type   Button type
 */

/**
 * @typedef OptionsObject
 * @type {object}
 * @property {string}   color                   Modal color
 * @property {string}   title                   Title
 * @property {string}   icon_type               Type of icon: fas or far
 * @property {string}   icon                    Font awesome icon (without 'fa')
 * @property {bool}     showIcon                Show icon
 * @property {bool}     hideAfterResolve        Should hide modal after resolve
 * @property {function} onResolve               Function that fires on resolve
 * @property {ConfirmModalButton[]} buttons     Buttons
 */

/**
 * Confirm modal
 * @param {string} text
 * @param {OptionsObject} [options]
 * @returns {Promise<boolean>}
 */
export const confirmModal = (text, options) => {
    return new Promise((resolve, reject) => {
        options = Object.assign({}, {
            color: 'warning',
            title: 'Potwierdź',
            showIcon: true,
            icon_type: 'fas',
            hideAfterResolve: true,
            icon: 'exclamation-circle',
            onResolve: null,
            buttons: [
                {
                    text: 'Nie',
                    color: 'outline-secondary'
                },
                {
                    text: 'Tak',
                    color: options ? (options.color ? options.color : 'warning') : 'warning',
                    type: 'resolve'
                },
            ]
        }, options);

        let modalDOM = $(`<div class="cm cm-${options.color} modal fade" tabindex="-1"></div>`);
        let modalDialog = $(`<div class="modal-dialog modal-dialog-centered"></div>`);
        let modalContent = $(`<div class="modal-content"></div>`);

        let icon = options.showIcon ? `
            <div class="col-4 col-sm-3 col-md-2 d-flex justify-content-center align-items-center">
                <i class="text-${options.color} fa-3x ${options.icon_type} fa-${options.icon}"></i>
            </div>
        ` : '';

        let modalBody = $(`
                <div class="modal-body py-4">
                    <div class="row">
                        ${icon}
                        <div class="${options.showIcon ? 'col-8 col-sm-9 col-md-10' : 'col-12'}">
                            <div class="row"><div class="col-12"><h4>${options.title}</h4></div></div>
                            <div class="row"><div class="col-12">${text}</div></div>
                        </div>
                    </div>
                </div>
            `);
        let modalFooter = $(`<div class="modal-footer"></div>`);

        for (let button of options.buttons) {
            let btn = $(`<button class="btn btn-${button.color}">${button.text}</button>`);

            btn.click(function() {
                $(this).off('click');
                if((button.type === 'resolve' && options.hideAfterResolve) || button.type !== 'resolve') {
                    modal.hide();

                    setTimeout(() => {
                        modalDOM.remove();
                    }, 1000);
                }

                if(button.type === 'resolve') {
                    if(options.onResolve) {
                        options.onResolve(this);
                    }

                    return resolve(true);
                } else if(button.type === 'reject') {
                    return reject();
                } else {
                    return resolve(false);
                }
            })

            modalFooter.append(btn);
        }

        modalContent.append(modalBody, modalFooter);
        modalDialog.append(modalContent);
        modalDOM.append(modalDialog);
        $('body').append(modalDOM);

        let modal = new bootstrap.Modal(modalDOM[0], {
            keyboard: false,
            backdrop: 'static'
        });
        modal.show();
    });
}
